import { Popup } from '../../js/front/Popup';

const popupInstances = new WeakMap();

document.querySelectorAll( '.b-button-with-popup.js-popup' ).forEach( ( block ) => {

	if ( ! popupInstances.has( block ) ) {

		popupInstances.set( block, new Popup( block ) );

	}

} );
